var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 339.8,
    height: 199.8,
    viewBox: "0 0 339.8 199.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2240",
    opacity: 0.67,
    filter: "url(#filter0_f_0_46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.9,
    cy: 99.9,
    rx: 101.5,
    ry: 31.5,
    fill: "#5E3DF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_46",
    x: 0,
    y: 0,
    width: 339.8,
    height: 199.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.2,
    result: "effect1_foregroundBlur_0_46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowLogo);
export default __webpack_public_path__ + "static/media/glow_logo.646a79759dd2b1ac490089f1bdbe1433.svg";
export { ForwardRef as ReactComponent };